// src/menu-items/rates.ts
//
// International and Belgian rates are two menu items rather than one page with
// a country tab: the Belgian table splits every price into peak and off-peak,
// so the two column sets barely overlap.
import { Globe, Home, DataTransferBoth, Search } from 'iconoir-react';

const rates = {
  id: 'rates-group',
  title: 'Rates',
  type: 'group',
  children: [
    {
      id: 'rates-international',
      title: 'International Rates',
      type: 'item',
      url: '/rates/international',
      icon: Globe,
      breadcrumbs: true
    },
    {
      id: 'rates-national',
      title: 'National Rates',
      type: 'item',
      url: '/rates/national',
      icon: Home,
      breadcrumbs: true
    },
    {
      // "Providers" in v3-admintool. Sits under Rates because a carrier is what
      // a rate's route field points at — the two are read together far more
      // often than either is read alone.
      id: 'rates-carriers',
      title: 'Carriers',
      type: 'item',
      url: '/rates/carriers',
      icon: DataTransferBoth,
      breadcrumbs: true
    },
    {
      // Not a rate table but a question about one: what rates-master would
      // actually charge for a number, after overrides and clip rules.
      id: 'rates-lookup',
      title: 'Rate Lookup',
      type: 'item',
      url: '/rates/lookup',
      icon: Search,
      breadcrumbs: true
    }
  ]
};

export default rates;
